import { Mol } from '@moleculeone/types';
import { SVGMol, SVGMolSpace } from '@moleculeone/ui';

import { styled } from '../../../../../../stitches.config';
import { useMolDrawing } from '../../../hooks/useMolDrawing';

const MOLECULE_SIZE = 150;

const Molecule = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '$4',
  backgroundColor: 'white',
  borderRadius: '$medium',
});

const MoleculeText = styled('p', {
  fontSize: '$2',
  marginTop: '$3',
});

type CompoundPreviewProps = {
  mol: Mol;
  onMouseDown: any;
  renderDelay?: number;
  text?: string;
};
export const CompoundPreview = ({ mol, onMouseDown, renderDelay = 0, text }: CompoundPreviewProps) => {
  const drawing = useMolDrawing({ mol, renderDelay });

  return (
    <Molecule>
      {drawing == null ? (
        <div style={{ width: MOLECULE_SIZE, height: MOLECULE_SIZE }} />
      ) : (
        <SVGMolSpace viewport={drawing.viewport} onMouseDown={onMouseDown} width={MOLECULE_SIZE} height={MOLECULE_SIZE}>
          <SVGMol drawnMol={drawing.drawnMol} />
        </SVGMolSpace>
      )}
      {text && <MoleculeText>{text}</MoleculeText>}
    </Molecule>
  );
};
